import { createSlice } from '@reduxjs/toolkit';
import { getAiSettings } from '../actions/getAiSettings';
export const initialParentAppState = {
  plugins: {},
  appName: '',
  aiSettings: {},
  queryParams: {
    copilotThreadId: null,
    copilotPrompt: undefined
  }
};
const parentAppSlice = createSlice({
  name: 'parentApp',
  initialState: initialParentAppState,
  extraReducers: builder => {
    builder.addCase(getAiSettings.fulfilled, (state, action) => {
      state.aiSettings = action.payload;
    });
  },
  reducers: {
    updateParentAppState: (state, action) => {
      var _state$plugins$plugin;
      const {
        appName,
        plugin,
        parentAppState,
        sessionId,
        pluginProps
      } = action.payload;
      state.appName = appName || state.appName;
      state.plugins[plugin] = Object.assign({}, state.plugins[plugin], {
        sessionId,
        parentAppState: parentAppState || ((_state$plugins$plugin = state.plugins[plugin]) === null || _state$plugins$plugin === void 0 ? void 0 : _state$plugins$plugin.parentAppState)
      }, pluginProps || {});
    },
    setIsWaitingForExtraIntentProperties: state => {
      state.plugins = Object.keys(state.plugins).reduce((acc, plugin) => {
        acc[plugin] = Object.assign({}, state.plugins[plugin], {
          waitingForExtraIntentProperties: true
        });
        return acc;
      }, {});
    },
    updateExtraIntentProperties: (state, action) => {
      const {
        plugin,
        extraIntentProperties
      } = action.payload;
      state.plugins[plugin] = Object.assign({}, state.plugins[plugin], {
        extraIntentProperties,
        waitingForExtraIntentProperties: false
      });
    },
    setCopilotQueryParams: (state, action) => {
      state.queryParams = action.payload;
    },
    resetParentAppState: () => {
      return initialParentAppState;
    }
  }
});
export const {
  updateParentAppState,
  setIsWaitingForExtraIntentProperties,
  updateExtraIntentProperties,
  resetParentAppState,
  setCopilotQueryParams
} = parentAppSlice.actions;
export default parentAppSlice.reducer;